<!--  -->
<template>
  <section class="">
    <div v-if="isPendingPayment" class="price-item">
      <LineStep
        class="item-step"
        :isStep1="PayType == ORDER_MONEY_PAY_TYPE.prePayOrder"
      ></LineStep>
      <div class="item-content">
        <div class="item">
          <div class="">
            {{
              PayType == ORDER_MONEY_PAY_TYPE.prePayOrder ? '需' : '已'
            }}支付定金
          </div>
          <div class=" ">
            <i>&yen;</i
            ><i class="pf-medium">{{ product.preOrderPrice | priceNum }}</i>
          </div>
        </div>
        <div class="item">
          <div class="">剩余尾款</div>
          <div class="">
            <i>&yen;</i
            ><i class="pf-medium">{{ product.endPayPrice | priceNum }}</i>
          </div>
        </div>
        <div class="item" v-if="product.wholeDiscount">
          <div class="">尾款优惠</div>
          <div class=" ">
            <i>&yen;</i
            ><i class="pf-medium">{{ product.wholeDiscount | priceNum }}</i>
          </div>
        </div>
        <div class="pedding">
          <div class="pedding-title">待支付</div>
          <div class="pedding-count">
            <i>&yen;</i>{{ endOrderPrice | priceNum }}
          </div>
        </div>
      </div>
    </div>
    <div v-else class="price-item">
      <div class="item-content">
        <div class="item" v-if="product.Id">
          <div class="title">商品总额</div>
          <div class="content">
            <i>&yen;</i><i class="pf-medium">{{ product.Price | priceNum }}</i>
          </div>
        </div>
        <div class="item">
          <div class="">定金</div>
          <div class=" ">
            <i>&yen;</i
            ><i class="pf-medium">{{ product.preOrderPrice | priceNum }}</i>
          </div>
        </div>
        <div class="item">
          <div class="">尾款</div>
          <div class=" ">
            <i>&yen;</i
            ><i class="pf-medium">{{ product.endPayPrice | priceNum }}</i>
          </div>
        </div>
        <div class="item" v-if="product.wholeDiscount">
          <div class="">优惠</div>
          <div class=" ">
            <i>&yen;</i
            ><i class="pf-medium">{{ product.wholeDiscount | priceNum }}</i>
          </div>
        </div>
        <div class="pedding">
          <div class="pedding-title">实付款</div>
          <div class="pedding-count">
            <i>&yen;</i><i class="pf-medium">{{ order.payPrice | priceNum }}</i>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import mixProm from '@/mixin/mixProm'
import { ORDER_MONEY_PAY_TYPE, ORDER_STATE_ENUM } from '@/config'
import LineStep from '../../line-step/index'

export default {
  mixins: [mixProm],
  //import引入的组件需要注入到对象中才能使用
  components: {
    LineStep
  },
  data() {
    //这里存放数据
    return {
      ORDER_MONEY_PAY_TYPE,
      isPendingPayment: this.order.orderState == ORDER_STATE_ENUM.PENDING_PAY
    }
  },
  props: {
    order: {
      type: Object,
      default() {
        return {}
      }
    },
    product: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  //监听属性 类似于data概念
  computed: {
    wholeDiscount() {
      return this.product.discountAmt + this.product.reduceInfo
    },
    endOrderPrice() {
      let _temp = ''
      //当前是支付定金状态
      if (this.PayType == ORDER_MONEY_PAY_TYPE.prePayOrder) {
        _temp = this.product.preOrderPrice
      } else {
        _temp = this.product.endOrderPrice - this.product.wholeDiscount
      }
      return _temp
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {}
}
</script>
<style lang="scss" scoped>
@import '../../../assets/css/mixin';
//@import url(); 引入公共css类
.price-item {
  display: flex;
  .item-step {
    margin-left: rem(45px);
    margin-top: rem(38px);
  }
  .item-content {
    padding-right: rem(24px);
    flex: 1;
    margin-left: rem(17px);
    font-size: rem(26px);
    .item {
      display: flex;
      margin-bottom: rem(24px);
      justify-content: space-between;
      .title {
      }
      .conntent {
        font-weight: 700;
      }
    }
    .item:first-child {
      margin-top: rem(24px);
    }
    .pedding {
      display: flex;
      justify-content: flex-end;
      margin-bottom: rem(8px);
      font-size: rem(26px);
      .pedding-title {
        font-weight: 500;
      }
      .pedding-count {
        font-weight: 500;
        font-size: rem(32px);
        color: #ff5900;
        font-weight: 700;
        line-height: rem(30px);
        margin-left: rem(24px);
      }
    }
  }
}
</style>
